import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';

@Directive({
  selector: 'input[appFormatRut]'
})
export class FormatRutDirective {
  constructor(private ctrl: NgControl, private rutFormatterService: RutFormatterService) { }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const rutOriginal = (event.target as HTMLInputElement).value;
    const rutFormat = this.transform(rutOriginal);

    if (rutOriginal !== rutFormat) {
      this.ctrl.control.setValue(rutFormat);
      event.stopPropagation();
    }
  }
  transform(value: string): string {
    return this.rutFormatterService.format(value);
  }
}
